export default class PublicationPolicy {
    /* eslint-disable-next-line no-unused-vars */
    static browse(user, publication) {
        return user.hasPermissionTo('browse:publications');
    }

    /* eslint-disable-next-line no-unused-vars */
    static read(user, publication) {
        return user.hasPermissionTo('read:publications');
    }

    static edit(user, publication) {
        return publication.deleted_at === null
            && user.hasPermissionTo('edit:publications');
    }

    static add(user) {
        return user.hasPermissionTo('add:publications');
    }

    static destroy(user, publication) {
        return publication.deleted_at === null
            && user.hasPermissionTo('delete:publications');
    }

    static restore(user, publication) {
        return publication.deleted_at !== null
            && user.hasPermissionTo('delete:publications');
    }
}
